import { render, staticRenderFns } from "./DepartmentEmployee.vue?vue&type=template&id=c87d194e&scoped=true&"
import script from "./DepartmentEmployee.vue?vue&type=script&lang=js&"
export * from "./DepartmentEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentEmployee.vue?vue&type=style&index=0&id=c87d194e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87d194e",
  null
  
)

export default component.exports